import { styled } from "styled-components";
const DropdownMenuSeparatorComponent = styled("hr")(
  ({ theme }) => ({
    borderColor: theme.borderColor,
    borderStyle: "solid",
    borderWidth: "0 0 1px",
    boxSizing: "border-box",
    height: 1,
    margin: "4px -4px"
  }),
  ({ spacing }) => ({
    default: {
      marginLeft: -4,
      marginRight: -4
    },
    none: {
      marginLeft: 0,
      marginRight: 0
    }
  })[spacing]
);
export {
  DropdownMenuSeparatorComponent
};
